import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { useContext, useEffect } from "react";
import { UserContext } from "../../context";
import { isValidSession } from "../../utils/sessionStorage";

const AdminAppLayout = () => {
  const location = useLocation();
  const nav = useNavigate();

  const { actions: ua } = useContext(UserContext);

  useEffect(() => {
    if (!ua.hasRole("admin.app")) {
      nav("/");
    }
  }, []);

  // if (!isValidSession()) return null;

  return <>{ua.hasRole("admin.app") ? <Outlet /> : null}</>;
};

export default AdminAppLayout;
